import { SimpleGrid, Text } from "@chakra-ui/react";
import { Section } from "components/section";
import { type CdpIndustryUseCase, useCdpIndustry } from "contexts/cdp-industry-context";
import React from "react";
import { FilterTabs } from "ui/tabs";
import { TextColumn, TextTitle } from "ui/text";
import { capitalizeFirstLetter } from "utils";

function UseCasesGrid({ useCases }: { useCases: CdpIndustryUseCase[] }) {
  const { industry } = useCdpIndustry();

  return (
    <SimpleGrid columns={{ base: 1, md: 3 }} columnGap="small" rowGap="biggest">
      {useCases.map((useCase) => (
        <TextColumn
          key={useCase.title}
          iconChip={{ variant: industry.color, icon: useCase.icon }}
          title={useCase.title}
          description={useCase.description}
        />
      ))}
    </SimpleGrid>
  );
}

export function CdpIndustryUseCases() {
  const { industry } = useCdpIndustry();

  return (
    <Section>
      <TextTitle
        size="lg"
        align="center"
        titleAs="div"
        title={
          <Text as="h2" sx={capitalizeFirstLetter}>
            {industry.abbreviatedName ?? industry.name} use cases
          </Text>
        }
      />

      <FilterTabs
        mt="bigger"
        tabs={[
          { label: "Performance marketing", items: <UseCasesGrid useCases={industry.useCases.performanceMarketing} /> },
          { label: "Lifecycle marketing", items: <UseCasesGrid useCases={industry.useCases.lifecycleMarketing} /> },
          {
            label: "Onsite personalization",
            items: <UseCasesGrid useCases={industry.useCases.onsitePersonalization} />,
          },
        ]}
      />
    </Section>
  );
}
